import { setupSwiper } from "../utils/swiper-setup";

document.addEventListener("DOMContentLoaded", () => {
  const projectModules = document.querySelectorAll(".component__text-media");
  projectModules.forEach((module) => {
    const swiper = module.querySelector(".swiper");
    if (swiper) {
      setupSwiper(swiper.id, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: module.querySelector("#" + swiper.id + "-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: module.querySelector("#" + swiper.id + "-next"),
          prevEl: module.querySelector("#" + swiper.id + "-prev"),
        },
      });
    }
  });
});
